export default [
  {
    date: "1452710825018",
    row: 5,
    col: 9,
    segments: [
      [3, 1, 1, 3],
      [1, 3, 3, 5],
      [3, 5, 3, 4],
      [3, 2, 3, 1],
      [3, 4, 7, 4],
      [7, 4, 7, 5],
      [7, 5, 9, 3],
      [9, 3, 7, 1],
      [7, 1, 7, 2],
      [7, 2, 3, 2]
    ]
  }
];
